namespace GeniuzPOS.Product {
    export interface CsMatTypeForm {
        MatTypeId: Serenity.StringEditor;
        MatTypeName: Serenity.StringEditor;
    }

    export class CsMatTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsMatType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsMatTypeForm.init)  {
                CsMatTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsMatTypeForm, [
                    'MatTypeId', w0,
                    'MatTypeName', w0
                ]);
            }
        }
    }
}
